import _noop from "lodash/noop";
import _get from "lodash/get";
import _Set from "@babel/runtime-corejs3/core-js-stable/set";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";

/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ColGroup from './ColGroup';
import TableHeader from './TableHeader';
/**
 * When there are fixed columns, the header is rendered as a separate Table
 */

class HeadTable extends React.PureComponent {
  constructor() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      selectedRowKeysSet: new _Set()
    };
    super(props);
  }

  render() {
    const {
      scroll,
      prefixCls,
      fixed,
      forwardedRef,
      handleBodyScroll,
      columns,
      components,
      onDidUpdate,
      showHeader,
      anyColumnFixed,
      bodyHasScrollBar
    } = this.props;

    if (!showHeader) {
      return null;
    }

    const Table = _get(components, 'header.outer', 'table');

    const x = _get(scroll, 'x');

    const headStyle = {};
    const tableStyle = {};

    if (x && !fixed) {
      tableStyle.width = x;
    }

    if (bodyHasScrollBar) {
      headStyle.overflowY = 'scroll';
    }

    const colgroup = /*#__PURE__*/React.createElement(ColGroup, {
      columns: columns,
      prefixCls: prefixCls
    });
    const tableHeader = /*#__PURE__*/React.createElement(TableHeader, _Object$assign({}, this.props, {
      columns: columns,
      components: components,
      onDidUpdate: onDidUpdate
    }));
    return /*#__PURE__*/React.createElement("div", {
      key: "headTable",
      style: headStyle,
      className: "".concat(prefixCls, "-header"),
      ref: forwardedRef,
      onScroll: handleBodyScroll
    }, /*#__PURE__*/React.createElement(Table, {
      style: tableStyle,
      className: classnames(prefixCls, {
        ["".concat(prefixCls, "-fixed")]: anyColumnFixed
      })
    }, colgroup, tableHeader));
  }

}

HeadTable.propTypes = {
  anyColumnFixed: PropTypes.bool,
  bodyHasScrollBar: PropTypes.bool,
  columns: PropTypes.array,
  components: PropTypes.object,
  dataSource: PropTypes.array,
  fixed: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  handleBodyScroll: PropTypes.func,
  prefixCls: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  scroll: PropTypes.shape({
    x: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
    y: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  selectedRowKeysSet: PropTypes.instanceOf(_Set).isRequired,
  showHeader: PropTypes.bool,
  onDidUpdate: PropTypes.func
};
HeadTable.defaultProps = {
  handleBodyScroll: _noop
};
export default /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(HeadTable, _Object$assign({}, props, {
  forwardedRef: ref
})));